import { render, staticRenderFns } from "./EditTabInformation.vue?vue&type=template&id=f8302d1e"
import script from "./EditTabInformation.vue?vue&type=script&lang=js"
export * from "./EditTabInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports